import { UserRole } from '@/types';
import { IsEmail, IsNotEmpty } from 'class-validator';

export class TeamInviteInput {
  @IsNotEmpty({ message: 'Please enter your first name' })
  firstName: string;

  @IsNotEmpty({ message: 'Please enter your last name' })
  lastName: string;

  @IsNotEmpty({ message: 'Please enter your email' })
  @IsEmail({}, { message: 'Please enter a valid email' })
  email: string;

  @IsNotEmpty({ message: 'Please select a role' })
  role: UserRole | string;
}
